import { PageController } from '@client/components/_core/layout/PageController';
import { HostedLodgementFlow } from '@client/components/lodgement/hosted/HostedLodgementFlow';
import { createFileRoute } from '@tanstack/react-router';

/** The public URL on a lodgement link: `/lodge/{key}`. */
export const Route = createFileRoute('/lodge/$key')({ component: LodgeByKey });

function LodgeByKey() {
    const { key } = Route.useParams();
    return (
        <PageController route={Route}>
            <HostedLodgementFlow key={key} source={{ kind: 'link', key }} />
        </PageController>
    );
}
